import { motion } from "framer-motion";
import AnimatedCounter from "../HeroSection/AnimatedCounter";

/**
 * AnimatedCounter از Hero دوباره استفاده می‌شه.
 * چون ارقام فارسی/عربی رو خودش locale می‌کنه.
 */
export default function StatBox({ to, decimals = 0, suffix, suffixEn, suffixAr, label, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{
        delay: index * 0.1,
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1],
      }}
      className="text-center"
    >
      <b className="block bg-gradient-to-br from-white to-gold-3 bg-clip-text text-[34px] font-black leading-none tracking-[-2px] text-transparent sm:text-[42px] lg:text-[54px]">
        <AnimatedCounter
          to={to}
          decimals={decimals}
          suffix={suffix}
          suffixEn={suffixEn}
          suffixAr={suffixAr}
        />
      </b>
      <span className="mt-3 block text-[12.5px] font-medium text-white/85 sm:mt-4 sm:text-[14px]">
        {label}
      </span>
    </motion.div>
  );
}